import { useState, useEffect } from 'react';
import ResultsMap from './results-map';

const ExploreMore = ({ regionId, state, county, countyId, resultsForMap, expandedProperty, onSelectedMapProperty, reloadSelectedProperty }) => {   
    const [mapResultForSingleProperty, setMapResultForSingleProperty] = useState(null);

    useEffect(() => {
        if (resultsForMap && expandedProperty) {
            const filteredResult = resultsForMap.filter(r => r.parcelId === expandedProperty.parcelId);
            setMapResultForSingleProperty(filteredResult);
        }
    }, [resultsForMap, expandedProperty]);


    return (
        <div>
            <ResultsMap id="exploreMore" regionId={regionId} countyId={countyId} parcelsToShowOnMap={mapResultForSingleProperty} mapStateAbbrev={state} mapCounty={county} expandedProperty={expandedProperty} onSelectedMapProperty={onSelectedMapProperty} reloadSelectedProperty={reloadSelectedProperty} exploreMore={true} />
        </div>    
    );     
}

export default ExploreMore;